// extracted by mini-css-extract-plugin
export default {"root":"OrderTotal-module_root_e489ca","text":"OrderTotal-module_text_b92929","hideTotal":"OrderTotal-module_hideTotal_de9496","centered":"OrderTotal-module_centered_e622a1"};